import includes from 'lodash/includes'

import asyncAction from 'modules/core/lib/asyncAction'
import { Collection } from 'modules/core/lib/mobx-rest'

import Leave from 'modules/timeoff/store/models/Leave'

class Leaves extends Collection<Leave> {
  get cacheKey(): string {
    return 'timeoffLeaves'
  }

  get indexes() {
    return ['employee_id']
  }

  model() {
    return Leave
  }

  isDischargeFull(medicalLeaveType: string): boolean {
    const { maternity, paternity, lactation } = Leave.medicalLeaveTypes

    return !includes([maternity, paternity, lactation], medicalLeaveType)
  }

  async rpcCreateMultipleLeaves(data: object, employeeIds: number[]) {
    const result = await asyncAction(() =>
      this.rpc('bulk_create', { ...data, employee_ids: employeeIds })
    )

    if (result.success) this.set(result.value)

    return result
  }
}

const singleton: Leaves = new Leaves()

export { Leaves }

export default singleton
